function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__ic_light-a",
  d: "M20 11h3v2h-3v-2zM1 11h3v2H1v-2zM12.992.999v3h-2v-3h2zM4.925 3.516l2.121 2.121-1.414 1.414L3.51 4.93l1.414-1.414zm12.027 2.116l2.121-2.12 1.415 1.413-2.122 2.122-1.414-1.415zM12 6a6 6 0 0 1 3 11.197V19a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1.803A6 6 0 0 1 12 6zm2 15v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1h4zm-3-3h2v-2.126A4.002 4.002 0 0 0 12 8a4 4 0 0 0-1 7.874V18z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__ic_light-a"
});

var SvgIcLight = function SvgIcLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_light.5ffe22d5.svg";
export { ForwardRef as ReactComponent };